import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { NotificationManager } from 'react-notifications';
import moment from 'moment';
import Selectsearch from "react-select"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import CircularProgress from '@mui/material/CircularProgress';
import { TextField, MenuItem } from "@mui/material";
import {
	FormGroup,
	Label,
	Input,
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import {   
    allStudents,
    checkMskAssessment,
    addMskAssessment,
    fetchPostureList,
    getMedicalDetails
 } from 'Actions';



class AddMSKElements extends React.Component {
   
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    static num1 = 0;

    UNSAFE_componentWillMount() {
		this.props.allStudents();  
      this.props.fetchPostureList();   
	}
   constructor(props) {
      
      super(props);
      this.state = {
                  student: '',
                  quarter:'',
                  seldate:'',
                  actionvalue:'',
                  addinnerdiv:false,
                  mskassessor:'',
                  mskskill:'',
                  allergies:'',
                  medicalhistory:'',
                  medicalrecord:'',
                  injuryhistory:'',
                  previousLength:0,
                  valuelength:0,
                  loader:false,
         };

        
   }
   
   

    selectdate = (date) => {
        const seldate =moment(new Date(date)).format('yyyy-MM-DD');
        this.setState({ seldate:date });
        var student =this.state.student;
        var quater =this.state.quarter;
        this.props.checkMskAssessment(student, seldate, quater).then((data) => {         
            if(data.status==1){
                  this.props.getMedicalDetails(student, seldate, quater).then((data) => {  
                        if(data.status==1){
                           var resdata=data.data;
                           this.setState({ 
                              mskassessor:resdata[0].mskassessor,
                              mskskill:resdata[0].mskskill,
                              allergies:resdata[0].allergies,
                              medicalhistory:resdata[0].medicalhistory,
                              medicalrecord:resdata[0].medicalrecord,
                              injuryhistory:resdata[0].injuryhistory,
                           });
                           
                        }
                  }); 
               this.setState({ 
                  addinnerdiv:true
               });
            }else{
               NotificationManager.error('This year quater '+quater+' assement already exists');
               
               this.setState({ 
                  addinnerdiv:false
               });
            }
        })
        .catch((e) => {
        console.log(e);
        });  
        
    }

    

    addHandleSubmit(event){
        event.preventDefault();
        this.setState({loader:true });
        this.props.addMskAssessment(event).then((data) => {   
         this.setState({loader:false });
            if(data.status==1){
                    this.setState({ 
                        student: '',
                        quarter:'',
                        seldate:''
                    });
                    document.getElementById("addassessmentform").reset();
                    setTimeout(this.props.onClick, 5000);
            }
        });
        
    }

   handleInput(event) {
      const bullet = "\u2022";
      const inputValue = event.target.value;
      const cursorPosition = event.target.selectionStart;
      let lines = inputValue.split('\n');
    
      for (let i = 0; i < lines.length; i++) {
        const line = lines[i];
        if (!line.trim().startsWith(bullet)) {
          lines[i] = `${bullet} ${line.trimLeft()}`;
        }
      }
    
      let newValue = lines.join('\n');
      if (event.nativeEvent.inputType === 'deleteContentBackward') {
        if (cursorPosition === 0) {
          const lineIndex = newValue.substr(0, cursorPosition).split('\n').length - 1;
          if (lineIndex > 0) {
            const linesArray = newValue.split('\n');
            linesArray.splice(lineIndex, 1);
            newValue = linesArray.join('\n');
          }
        } else if (newValue[cursorPosition - 1] === bullet && (cursorPosition === newValue.length || newValue[cursorPosition] === '\n')) {
          newValue = newValue.slice(0, cursorPosition - 2) + newValue.slice(cursorPosition);
        }
      }
    
      event.target.value = newValue;
    
      this.setState({
        previousLength: newValue.length,
      });
   }
  

   render() {
      
      const { studentlists, posturehead, postureshoulders, posturethoracic, posturelumbar, posturepelvis, postureknee, posturefeet, postureglenohumeral, postureabbreivation, loading} = this.props;

      const allstudent=studentlists.map((stdval) => {  
            return {
               label: stdval.student,  
               value: stdval.uudID
            }
      });

      const styles = {
        
         tabletrtd: {
            
             wordWrap: "break-word",
             backgroundColor:"#fff",
             textAlign: "center"
         },
         tabletleft: {
             
             whiteSpace: "pre-line",
             wordWrap: "break-word",
             backgroundColor:"#fff"
         },
         tabletleft20: {
             
             whiteSpace: "pre-line",
             wordWrap: "break-word",
             backgroundColor:"#fff",
             width:"20%"
         },
         tabletleft30: {
             
             borderCollapase: "collapse",
             borderSpacing: "0px",
             width:"30%",
             backgroundColor:"#fff"
         },
         tabtrtd30: {
             
             width:"30%",
             backgroundColor:"#fff",
             fontWeight:"bold"
         },
         tabtrtd40: {
             borderWidth: "1px",
             borderStyle: "solid",
             borderColor: "black",
             borderCollapase: "collapse",
             borderSpacing: "0px",
             width:"40%",
             backgroundColor:"#fff",
             fontWeight:"bold"
         },
         tabtrtd20: {
           
             width:"20%",
             backgroundColor:"#fff",
             fontWeight:"bold"
         },
         tabtrtd10: {
             
             width:"10%",
             backgroundColor:"#fff",
             textAlign : "center"
         },
         tabtrtd15: {
             
             width:"15%",
             backgroundColor:"#fff",
             textAlign : "center"
         },
         tablehead: {
             
             textAlign: "center",
             fontWeight:"bold"
         },
         tablehead30: {
             borderWidth: "1px",
             borderCollapase: "collapse",
             borderSpacing: "0px",
             border:"1px soild black",
             borderColor:"black",
             borderStyle:'solid',
             backgroundColor:"#ccc",
             textAlign: "center",
             fontWeight:"bold",
             width:"30%"
         },
         tableheadblue: {
             borderWidth: "1px",
             borderStyle: "solid",
             borderColor: "black",
             borderCollapase: "collapse",
             borderSpacing: "0px",
             backgroundColor:"#ccc",
             textAlign: "center",
             fontWeight:"bold"
         },
         tableheadblue20: {
             borderWidth: "1px",
             borderStyle: "solid",
             borderColor: "black",
             borderCollapase: "collapse",
             borderSpacing: "0px",
             backgroundColor:"#ccc",
             width:"20%",
             textAlign: "center",
             fontWeight:"bold"
         },
         tableheadblue10: {
             borderWidth: "1px",
             borderStyle: "solid",
             borderColor: "black",
             borderCollapase: "collapse",
             borderSpacing: "0px",
             backgroundColor:"#ccc",
             width:"10%",
             textAlign: "center",
             fontWeight:"bold"
         },
         tableheadblue40: {
             borderWidth: "1px",
             borderStyle: "solid",
             borderColor: "black",
             borderCollapase: "collapse",
             borderSpacing: "0px",
             backgroundColor:"#ccc",
             width:"40%",
             textAlign: "center",
             fontWeight:"bold"
         },
         mainheading:{
             padding: "10px 20px 20px 20px",
             backgroundColor: "rgb(204 204 204)",
             border:"1px solid black",
             marginBottom: "30px",
             marginTop: "50px",
             width: "650px",
             display: "block",
             fontWeight:"bold"
         },
         secondheading :{
             fontWeight: "bold",
             marginBottom: "30px",
             marginTop:"20px"
         },
         subheading:{
             padding: "10px",
             backgroundColor: "#a4f3f3cc",
             border:"1px soild black",
             marginBottom:"10px",
             paddingRight:"30px"
         },
         errmessage:{
             textAlign:"center",
             color:"red"
         },
         rctcontent:{
             
             borderRadius: "5px",
             boxShadow: "0 1px 15px 1px rgba(69, 65, 78, 0.08)",
             border: "none",
             transition: "all 0.4s ease-in-out 0s",
             marginBottom: "24px",
             position: "relative"
 
         },
         buttonProgress: {
            color: "blue",
            position: 'absolute',
            top: '65%',
            left: '50%',
            marginTop: -15,
            marginLeft: -15,
        },
        wrapper: {
            position: 'relative',
            textAlign:"center"
        },
       };

      return (
           <div>
               <div className="col-lg-12">
                     <form autoComplete="off" id="addassessmentform" onSubmit={(e)=>this.addHandleSubmit(e)}>
                        <div className="row">
                        <div className="col-sm-12 col-lg-6">
                           <RctCollapsibleCard heading="Create MSK Assessment">   
                                    <div className="row float-right"> 
                                       <button type="button" className="mr-3 mb-3 btn btn-outline-warning float-right" onClick={this.props.onClick} >Back</button>
                                    </div>                           
                                 <div className="row">
                                        
                                       <div className="col-sm-12 col-lg-8"> 
                                             <FormGroup>
                                                <Label for="Select">Student *</Label>
                                                <Selectsearch className="form-control h-auto w-100" id="student" name="student" options={allstudent} value={allstudent.find(obj => obj.value === this.state.student)} onChange={evt => this.setState({ student: evt.value })} required/>
                                             </FormGroup>
                                       </div>   
                                       <div className="col-sm-12 col-lg-8">
                                          <FormGroup>
                                             <Label for="Select">Assessment No *</Label>
                                             <Input type="select" name="quarter" id="quarter" required value={this.state.quarter} onChange={evt => this.setState({quarter: evt.target.value})}>
                                                <option value=""> </option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option> 
                                                <option value="4">4</option>                                                
                                             </Input>
                                          </FormGroup>
                                       </div> 
                                       <div className="col-sm-12 col-lg-8">
                                          <FormGroup>
                                             <Label for="Email-3">Select Assessment Date *</Label>
                                             <DatePicker className="form-control" id="seldate"  name="seldate" autoComplete="off" required
                                                      selected={this.state.seldate}
                                                      onChange={this.selectdate}
                                                      dateFormat='yyyy-MM-dd'
                                                      peekNextMonth
                                                      showMonthDropdown
                                                      showYearDropdown
                                                      dropdownMode="select"
                                                   /> 
                                          </FormGroup>                                          
                                       </div>   
                                 </div>
                           </RctCollapsibleCard>  
                        </div> 
                        {this.state.addinnerdiv &&

                           <div className="col-sm-12 col-lg-6">
                           <RctCollapsibleCard>                              
                                 <div className="row">
                                       <div className="col-sm-12 col-lg-6"> 
                                          <FormGroup>
                                             <Label for="Select">MSK Assessor *</Label>
                                             <Input type="text" name="mskassessor" id="mskassessor" required value={this.state.mskassessor}  onChange={evt => this.setState({mskassessor: evt.target.value})}/>
                                          </FormGroup>
                                       </div> 
                                       <div className="col-sm-12 col-lg-6"> 
                                          <FormGroup>
                                             <Label for="Select">Skill</Label>
                                             <textarea rows="2" type="text" name="mskskill" id="mskskill" className="form-control form-control-alternative" value={this.state.mskskill} onChange={evt => this.setState({mskskill: evt.target.value})} ></textarea>
                                          </FormGroup>
                                       </div> 
                                       <div className="col-sm-12 col-lg-6"> 
                                          <FormGroup>
                                             <Label for="Select">Medical History</Label>
                                             <textarea rows="2" type="text" name="medicalhistory" id="medicalhistory" className="form-control form-control-alternative" defaultValue={this.state.medicalhistory} onChange={evt => this.handleInput(evt)}></textarea>
                                             </FormGroup>
                                       </div> 
                                       <div className="col-sm-12 col-lg-6"> 
                                          <FormGroup>
                                             <Label for="Select">Medical Record</Label>
                                             <Input type="select" name="medicalrecord" id="medicalrecord" value={this.state.medicalrecord} onChange={evt => this.setState({medicalrecord: evt.target.value})}>
                                                <option value=""> </option>
                                                <option value="Submitted">Submitted</option>
                                                <option value="Awaited">Awaited</option>
                                                <option value="Not Relevant"> Not Relevant</option>                                                
                                             </Input>
                                          </FormGroup>
                                       </div> 
                                       <div className="col-sm-12 col-lg-6"> 
                                          <FormGroup>
                                             <Label for="Select">Allergies</Label>
                                             <textarea rows="2" type="text" name="allergies" id="allergies" className="form-control form-control-alternative"  defaultValue={this.state.allergies} onChange={evt => this.handleInput(evt)}></textarea>
                                          </FormGroup>
                                       </div> 
                                       <div className="col-sm-12 col-lg-6"> 
                                          <FormGroup>
                                             <Label for="Select">Injury History</Label>
                                             <textarea rows="2" type="text" name="injuryhistory" id="injuryhistory" className="form-control form-control-alternative"  defaultValue={this.state.injuryhistory} onChange={evt => this.handleInput(evt)}></textarea>
                                          </FormGroup>
                                       </div> 
                                 </div>
                           </RctCollapsibleCard>  
                           </div> 
                        }
                        </div>
                        {this.state.addinnerdiv &&
                       
                        <div className="row">
                           <div className="col-sm-12 col-lg-12">
                              <h3 className="text-center">MUSCULOSKELETAL SCREENING</h3>
                           </div> 
                           <div className="col-sm-12 col-lg-12">
                              <RctCollapsibleCard heading="Component 1 - Posture"> 
                                 <div className="table-responsive">                                 
                                    <table className="table align-items-center table-flush">
                                          <thead className="thead-light">
                                             <th>Regions</th>
                                             <th className="text-center">Impression</th>
                                             <th className="text-center">Approach</th>
                                          </thead>
                                          <tbody>
                                             <tr>
                                                <td style={styles.tabtrtd20}>Head</td>
                                                <td style={styles.tabtrtd20}>
                                                   <FormGroup>
                                                      <Input type="select" name="head" id="head">
                                                         <option value=""> </option>
                                                         {posturehead.map((headval) => (
                                                             <option value={headval.phl_name}>{headval.phl_name}</option>                                                               
                                                         ))}
                                                      </Input>
                                                   </FormGroup>
                                                </td>
                                                <td rowSpan="3"><textarea rows="5" type="text" name="head_approach" id="head_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                             </tr>
                                             <tr>
                                                <td>Shoulders</td>
                                                <td>
                                                   <FormGroup>
                                                      <Input type="select" name="shoulders" id="shoulders">
                                                         <option value=""></option>
                                                         {postureshoulders.map((shldval) => (
                                                             <option value={shldval.psl_name}>{shldval.psl_name}</option>                                                               
                                                         ))}
                                                      </Input>
                                                   </FormGroup>
                                                </td>
                                             </tr>
                                             <tr >
                                                <td>Thoracic Spine</td>
                                                <td>
                                                   <FormGroup>
                                                      <Input type="select" name="thoracic_spine" id="thoracic_spine">
                                                         <option value=""> </option>
                                                         {posturethoracic.map((thspval) => (
                                                             <option value={thspval.ptl_name}>{thspval.ptl_name}</option>                                                               
                                                         ))}
                                                      </Input>
                                                   </FormGroup>
                                                </td>
                                                
                                             </tr>
                                             <tr>
                                                <td>Lumbar Spine</td>
                                                <td>
                                                   <FormGroup>
                                                      <Input type="select" name="lumbar_spine" id="lumbar_spine">
                                                         <option value=""> </option>
                                                         {posturelumbar.map((lumbval) => (
                                                             <option value={lumbval.pll_name}>{lumbval.pll_name}</option>                                                               
                                                         ))}
                                                      </Input>
                                                   </FormGroup>
                                                </td>
                                                <td rowSpan="2"><textarea rows="4" type="text" name="spine_approach" id="spine_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                             </tr>
                                             <tr>
                                                <td>Pelvis</td>
                                                <td>
                                                   <FormGroup>
                                                      <Input type="select" name="spine_pelvis" id="spine_pelvis">
                                                         <option value=""></option>
                                                         {posturepelvis.map((pelsval) => (
                                                             <option value={pelsval.ppl_name}>{pelsval.ppl_name}</option>                                                               
                                                         ))}
                                                      </Input>
                                                   </FormGroup>
                                                </td>
                                             </tr>
                                             <tr>
                                                <td>Knee Posture</td>
                                                <td>
                                                   <FormGroup>
                                                      <Input type="select" name="knee_posture" id="knee_posture">
                                                         <option value=""> </option>
                                                         {postureknee.map((kneval) => (
                                                             <option value={kneval.pkl_name}>{kneval.pkl_name}</option>                                                               
                                                         ))}
                                                      </Input>
                                                   </FormGroup>
                                                </td>                                                
                                                <td><textarea rows="2" type="text" name="knee_approach" id="knee_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                             </tr>
                                             <tr>
                                                <td>Feet</td>
                                                <td>
                                                   <FormGroup>
                                                      <Input type="select" name="feet" id="feet">
                                                         <option value=""> </option>
                                                         {posturefeet.map((kneval) => (
                                                             <option value={kneval.pfl_name}>{kneval.pfl_name}</option>                                                               
                                                         ))}
                                                      </Input>
                                                   </FormGroup>
                                                </td> 
                                                <td><textarea rows="2" type="text" name="feet_approach" id="feet_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>                                              
                                             </tr>
                                             <tr>
                                                <td>Glenohumeral Rhythm</td>
                                                <td>
                                                   <FormGroup>
                                                      <Input type="select" name="glenohumeral_rhythm" id="glenohumeral_rhythm">
                                                         <option value=""> </option>
                                                         {postureglenohumeral.map((gleval) => (
                                                             <option value={gleval.pgl_name}>{gleval.pgl_name}</option>                                                               
                                                         ))}
                                                      </Input>
                                                   </FormGroup>
                                                </td> 
                                                <td><textarea rows="2" type="text" name="glenohumeral_approach" id="glenohumeral_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                             </tr>                                             
                                          </tbody>
                                    </table>
                                 </div>
                              </RctCollapsibleCard>  
                           </div> 
                           <div className="col-sm-12 col-lg-12">
                              <RctCollapsibleCard heading="Component 2 - Upper Limb Tests"> 
                                 <div className="table-responsive">
                                 
                                    <table className="table align-items-center table-flush">
                                          <thead className="thead-light">
                                             <th className="text-center" style={styles.tabtrtd20}>Test</th>
                                             <th className="text-center" style={styles.tabtrtd10}>RT</th>
                                             <th className="text-center" style={styles.tabtrtd10}>LT</th>
                                             <th className="text-center" style={styles.tabtrtd10}>Goal</th>
                                             <th className="text-center">Impression</th>
                                             <th className="text-center">Approach</th>
                                          </thead>
                                          <tbody>
                                             <tr>
                                                <td>Shoulder Internal Rotation</td>
                                                <td><input type="text" name="shoulders_internal_rota_n_rt" id="shoulders_internal_rota_n_rt" className="form-control form-control-alternative"  maxLength="6" /></td>
                                                <td><input type="text" name="shoulders_internal_rota_n_lt" id="shoulders_internal_rota_n_lt" className="form-control form-control-alternative"  maxLength="6" /></td>
                                                <td><input type="text" name="shoulders_internal_rota_goal" id="shoulders_internal_rota_goal" className="form-control form-control-alternative" value="&#8805;90&#176;" disabled/></td>
                                                <td rowSpan="2"><textarea rows="4" type="text" name="shoulders_internal_impression" id="shoulders_internal_impression" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                <td rowSpan="2"><textarea rows="4" type="text" name="shoulders_internal_approach" id="shoulders_internal_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                             </tr>
                                             <tr>
                                                <td>Shoulder External Rotation</td>
                                                <td><input type="text" name="shoulders_external_rota_rt" id="shoulders_external_rota_rt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="shoulders_external_rota_lt" id="shoulders_external_rota_lt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="shoulders_external_rota_goal" id="shoulders_external_rota_goal" className="form-control form-control-alternative" value="&#8805;90&#176;" disabled/></td>
                                             </tr>
                                             <tr >
                                                <td>Infraspinatus Strength</td>
                                                <td><input type="text" name="gird_erg_rt" id="gird_erg_rt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="gird_erg_lt" id="gird_erg_lt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="gird_erg_rt_goal" id="gird_erg_rt_goal" className="form-control form-control-alternative" value="5 MMT" disabled/></td>
                                                <td><textarea rows="2" type="text" name="gird_erg_impression" id="gird_erg_impression" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                <td><textarea rows="2" type="text" name="gird_erg_approach" id="gird_erg_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>       
                                             </tr>
                                             <tr>
                                                <td>Kibler's 1</td>
                                                <td><input type="text" name="kibler_one_rt_one" id="kibler_one_rt_one" className="form-control form-control-alternative"  maxLength="6"/>
                                                <input type="text" name="kibler_one_rt_two" id="kibler_one_rt_two" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="kibler_one_lt_one" id="kibler_one_lt_one" className="form-control form-control-alternative"  maxLength="6"/>
                                                <input type="text" name="kibler_one_lt_two" id="kibler_one_lt_two" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="kibler_one_goal" id="kibler_one_goal" className="form-control form-control-alternative" value="&#8804;1.5cm" disabled/></td>
                                                <td rowSpan="3"><textarea rows="8" type="text" name="kibler_one_impression" id="kibler_one_impression" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                <td rowSpan="3"><textarea rows="8" type="text" name="kibler_one_approach" id="kibler_one_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                             </tr>
                                             <tr>
                                                <td>Kibler's 2</td>
                                                <td><input type="text" name="kibler_two_rt_one" id="kibler_two_rt_one" className="form-control form-control-alternative"  maxLength="6"/>
                                                <input type="text" name="kibler_two_rt_two" id="kibler_two_rt_two" className="form-control form-control-alternative"  maxLength="6"/></td>

                                                <td><input type="text" name="kibler_two_lt_one" id="kibler_two_lt_one" className="form-control form-control-alternative"  maxLength="6"/>
                                                <input type="text" name="kibler_two_lt_two" id="kibler_two_lt_two" className="form-control form-control-alternative"  maxLength="6"/></td>

                                                <td><input type="text" name="kibler_two_goal" id="kibler_two_goal" className="form-control form-control-alternative" value="&#8804;1.5cm" disabled/></td>
                                             </tr>
                                             <tr>
                                                <td>Kibler's 3</td>
                                                <td><input type="text" name="kibler_three_rt_one" id="kibler_three_rt_one" className="form-control form-control-alternative"  maxLength="6"/>
                                                <input type="text" name="kibler_three_rt_two" id="kibler_three_rt_two" className="form-control form-control-alternative"  maxLength="6"/></td>

                                                <td><input type="text" name="kibler_three_lt_one" id="kibler_three_lt_one" className="form-control form-control-alternative"  maxLength="6"/>
                                                <input type="text" name="kibler_three_lt_two" id="kibler_three_lt_two" className="form-control form-control-alternative"  maxLength="6"/></td>

                                                <td><input type="text" name="kibler_three_goal" id="kibler_three_goal" className="form-control form-control-alternative" value="&#8804;1.5cm" disabled/></td>                                                
                                             </tr>
                                             <tr>
                                                <td>Lat Muscle Length </td>
                                                <td><input type="text" name="lat_muscle_length_rt" id="lat_muscle_length_rt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                 <td><input type="text" name="lat_muscle_length_lt" id="lat_muscle_length_lt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="lat_muscle_length_goal" id="lat_muscle_length_goal" className="form-control form-control-alternative" value="&#8805;170&#176;" disabled/></td>
                                                <td><textarea rows="2" type="text" name="lat_muscle_impression" id="lat_muscle_impression" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                <td><textarea rows="2" type="text" name="lat_muscle_approach" id="lat_muscle_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td> 
                                             </tr>
                                          
                                          </tbody>
                                    </table>
                                 </div>
                              </RctCollapsibleCard>  
                           </div>

                           <div className="col-sm-12 col-lg-12">
                              <RctCollapsibleCard heading="Component 3 - Special Tests"> 
                                 <div className="table-responsive">
                                 
                                    <table className="table align-items-center table-flush">
                                          <thead className="thead-light">
                                             <th className="text-center" style={styles.tabtrtd20}>Test</th>
                                             <th className="text-center" style={styles.tabtrtd10}>RT/EXTN</th>
                                             <th className="text-center" style={styles.tabtrtd10}>LT/FLEX</th>
                                             <th className="text-center" style={styles.tabtrtd10}>Goal</th>
                                             <th className="text-center">Impression</th>
                                             <th className="text-center">Approach</th>
                                          </thead>
                                          <tbody>
                                             <tr>
                                                <td>HK Impingement Test</td>
                                                <td>
                                                      <select name="hk_impingement_test_rt" id="hk_impingement_test_rt" className="form-control form-control-alternative">                                                        
                                                         <option value="Negative">Negative</option>
                                                         <option value="Positive">Positive</option>
                                                      </select>
                                                </td>
                                                <td>
                                                      <select name="hk_impingement_test_lt" id="hk_impingement_test_lt" className="form-control form-control-alternative">
                                                         <option value="Negative">Negative</option>
                                                         <option value="Positive">Positive</option>
                                                      </select>

                                                </td>
                                                <td><input type="text" name="hk_impingement_test_goal" id="hk_impingement_test_goal" className="form-control form-control-alternative" value="Neg" disabled/></td>
                                                <td><textarea rows="2" type="text" name="hk_impingement_impression" id="hk_impingement_impression" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                <td><textarea rows="2" type="text" name="hk_impingement_approach" id="hk_impingement_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td> 
                                             </tr>
                                             <tr>
                                                <td>Empty Can Test</td>
                                                <td>
                                                      <select name="empty_can_test_rt" id="empty_can_test_rt" className="form-control form-control-alternative" >
                                                         <option value="Negative">Negative</option>
                                                         <option value="Positive">Positive</option>
                                                      </select>
                                                </td>
                                                <td>
                                                      <select name="empty_can_test_lt" id="empty_can_test_lt" className="form-control form-control-alternative" >
                                                         <option value="Negative">Negative</option>
                                                         <option value="Positive">Positive</option>
                                                      </select>
                                                </td>
                                                <td><input type="text" name="empty_can_test_goal" id="empty_can_test_goal" className="form-control form-control-alternative" value="Neg" disabled/></td>
                                                <td><textarea rows="2" type="text" name="empty_can_impression" id="empty_can_impression" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                <td><textarea rows="2" type="text" name="empty_can_approach" id="empty_can_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>       
                                             </tr>
                                             <tr >
                                                <td>Load And Shift Test</td>
                                                <td>
                                                      <select name="full_can_test_rt" id="full_can_test_rt" className="form-control form-control-alternative" >
                                                          <option value="Negative">Negative</option>
                                                         <option value="Positive">Positive</option>
                                                      </select>
                                                </td>
                                                <td>
                                                      <select name="full_can_test_lt" id="full_can_test_lt" className="form-control form-control-alternative" >
                                                         <option value="Negative">Negative</option>
                                                         <option value="Positive">Positive</option>
                                                      </select>
                                                </td>
                                                <td><input type="text" name="full_can_test_goal" id="full_can_test_goal" className="form-control form-control-alternative" value="Neg" disabled/></td>
                                                <td><textarea rows="2" type="text" name="full_can_impression" id="full_can_impression" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                <td><textarea rows="2" type="text" name="full_can_approach" id="full_can_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>             
                                             </tr>
                                             
                                             <tr>
                                                <td>Spine Quadrant Test</td>
                                                <td>
                                                      <select name="spine_quadrant_test_rt" id="spine_quadrant_test_rt" className="form-control form-control-alternative" >
                                                         <option value="Negative">Negative</option>
                                                         <option value="Positive">Positive</option>
                                                      </select>
                                                </td>
                                                <td>
                                                      <select name="spine_quadrant_test_lt" id="spine_quadrant_test_lt" className="form-control form-control-alternative" >
                                                         <option value="Negative">Negative</option>
                                                         <option value="Positive">Positive</option>
                                                      </select>
                                                </td>
                                                <td><input type="text" name="spine_quadrant_test_goal" id="spine_quadrant_test_goal" className="form-control form-control-alternative" value="Neg" disabled/></td>
                                                <td><textarea rows="2" type="text" name="spine_quadrant_impression" id="spine_quadrant_impression" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                <td><textarea rows="2" type="text" name="spine_quadrant_approach" id="spine_quadrant_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>       
                                             </tr>
                                             <tr>
                                                <td>Trendelenburg Sign</td>
                                                <td>
                                                      <select name="trendelenberg_sign_rt" id="trendelenberg_sign_rt" className="form-control form-control-alternative" >
                                                          <option value="Negative">Negative</option>
                                                         <option value="Positive">Positive</option>
                                                      </select>
                                                </td>
                                                <td>
                                                      <select name="trendelenberg_sign_lt" id="trendelenberg_sign_lt" className="form-control form-control-alternative" >
                                                         <option value="Negative">Negative</option>
                                                         <option value="Positive">Positive</option>
                                                      </select>
                                                </td>
                                                <td><input type="text" name="trendelenberg_sign_goal" id="trendelenberg_sign_goal" className="form-control form-control-alternative" value="Neg" disabled/></td>
                                                <td><textarea rows="2" type="text" name="trendelenberg_sign_impression" id="trendelenberg_sign_impression" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                <td><textarea rows="2" type="text" name="trendelenberg_sign_approach" id="trendelenberg_sign_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>       
                                             </tr>
                                             <tr>
                                                <td>Hip Quadrant Test</td>
                                                <td>
                                                      <select name="hip_quadrant_test_rt" id="hip_quadrant_test_rt" className="form-control form-control-alternative" >
                                                         <option value="Negative">Negative</option>
                                                         <option value="Positive">Positive</option>
                                                      </select>
                                                </td>
                                                <td>
                                                      <select name="hip_quadrant_test_lt" id="hip_quadrant_test_lt" className="form-control form-control-alternative" >
                                                          <option value="Negative">Negative</option>
                                                         <option value="Positive">Positive</option>
                                                      </select>
                                                </td>
                                                <td><input type="text" name="hip_quadrant_test_goal" id="hip_quadrant_test_goal" className="form-control form-control-alternative" value="Neg" disabled/></td>
                                                <td><textarea rows="2" type="text" name="hip_quadrant_impression" id="hip_quadrant_impression" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                <td><textarea rows="2" type="text" name="hip_quadrant_approach" id="hip_quadrant_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>       
                                             </tr>
                                             <tr>
                                                <td>Post. Impingement Test</td>
                                                <td>
                                                      <select name="post_impingement_test_rt" id="post_impingement_test_rt" className="form-control form-control-alternative" >
                                                         <option value="Negative">Negative</option>
                                                         <option value="Positive">Positive</option>
                                                      </select>
                                                </td>
                                                <td>
                                                      <select name="post_impingement_test_lt" id="post_impingement_test_lt" className="form-control form-control-alternative" >
                                                         <option value="Negative">Negative</option>
                                                         <option value="Positive">Positive</option>
                                                      </select>
                                                </td>
                                                <td><input type="text" name="post_impingement_test_goal" id="post_impingement_test_goal" className="form-control form-control-alternative" value="Neg" disabled/></td>
                                                <td><textarea rows="2" type="text" name="post_impingement_impression" id="post_impingement_impression" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                <td><textarea rows="2" type="text" name="post_impingement_approach" id="post_impingement_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>       
                                             </tr>
                                             <tr>
                                                <td>Sulcus Sign.(Shoulder)</td>
                                                <td>                                                      
                                                      <select name="infraspinatus_strength_rt" id="infraspinatus_strength_rt" className="form-control form-control-alternative" >
                                                         <option value="Negative">Negative</option>
                                                         <option value="Positive">Positive</option>
                                                      </select>
                                                </td>
                                                <td>                                                      
                                                      <select name="infraspinatus_strength_lt" id="infraspinatus_strength_lt" className="form-control form-control-alternative" >
                                                          <option value="Negative">Negative</option>
                                                         <option value="Positive">Positive</option>
                                                      </select>
                                                </td>
                                                <td><input type="text" name="infraspinatus_strength_goal" id="infraspinatus_strength_goal" className="form-control form-control-alternative" value="Neg" disabled/></td>
                                                <td><textarea rows="2" type="text" name="infraspinatus_strength_impression" id="infraspinatus_strength_impression" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                <td><textarea rows="2" type="text" name="infraspinatus_strength_approach" id="infraspinatus_strength_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>       
                                             </tr>
                                          </tbody>
                                    </table>
                                 </div>
                              </RctCollapsibleCard>  
                           </div> 

                           <div className="col-sm-12 col-lg-12">
                              <RctCollapsibleCard heading="Component 4 - Spine Tests"> 
                                    <div className="table-responsive">
                                    
                                       <table className="table align-items-center table-flush">
                                             <thead className="thead-light">
                                                <th className="text-center" style={styles.tabtrtd20}>Test</th>
                                                <th className="text-center" style={styles.tabtrtd10}>RT</th>
                                                <th className="text-center" style={styles.tabtrtd10}>LT</th>
                                                <th className="text-center" style={styles.tabtrtd10}>Goal</th>
                                                <th className="text-center">Impression</th>
                                                <th className="text-center">Approach</th>
                                             </thead>
                                             <tbody>
                                                <tr>
                                                   <td>Combined Elevation Test</td>
                                                   <td colSpan="3"><input type="text" name="combined_elevation_test" id="combined_elevation_test" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                   <td><textarea rows="2" type="text" name="combined_elevation_impression" id="combined_elevation_impression" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                   <td><textarea rows="2" type="text" name="combined_elevation_approach" id="combined_elevation_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>       
                                                </tr>
                                                <tr>
                                                   <td>Trunk Forward Flexion</td>
                                                   <td colSpan="2"><input type="text" name="trunk_forward_flexion" id="trunk_forward_flexion" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                   <td><input type="text" name="trunk_forward_flexion_goal" id="trunk_forward_flexion_goal" className="form-control form-control-alternative" value="&#8805;5cm" disabled/></td>
                                                   <td><textarea rows="2" type="text" name="trunk_forward_impression" id="trunk_forward_impression" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                   <td><textarea rows="2" type="text" name="trunk_forward_approach" id="trunk_forward_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>   
                                                </tr>
                                                <tr >
                                                   <td>Trunk Extension</td>
                                                   <td colSpan="2"><input type="text" name="trunk_extension" id="trunk_extension" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                   <td><input type="text" name="trunk_extension_goal" id="trunk_extension_goal" className="form-control form-control-alternative" value="&#8805;3cm" disabled/></td>
                                                   <td><textarea rows="2" type="text" name="trunk_extension_impression" id="trunk_extension_impression" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                   <td><textarea rows="2" type="text" name="trunk_extension_approach" id="trunk_extension_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>   
                                                </tr>
                                                <tr>
                                                   <td>Trunk side Flexion</td>
                                                   <td><input type="text" name="trunk_side_flexion_rt" id="trunk_side_flexion_rt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                   <td><input type="text" name="trunk_side_flexion_lt" id="trunk_side_flexion_lt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                   <td><input type="text" name="trunk_side_flexion_goal" id="trunk_side_flexion_goal" className="form-control form-control-alternative" value="&#8804;3cm" disabled/></td>
                                                   <td><textarea rows="2" type="text" name="trunk_side_impression" id="trunk_side_impression" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                   <td><textarea rows="2" type="text" name="trunk_side_approach" id="trunk_side_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>   
                                                </tr>
                                             
                                             </tbody>
                                       </table>
                                    </div>
                              </RctCollapsibleCard>  
                           </div> 

                           <div className="col-sm-12 col-lg-12">
                              <RctCollapsibleCard heading="Component 5 - Lower Limb Tests"> 
                                 <div className="table-responsive">
                                 
                                    <table className="table align-items-center table-flush">
                                          <thead className="thead-light">
                                             <th className="text-center" style={styles.tabtrtd20}>Test</th>
                                             <th className="text-center" style={styles.tabtrtd10}>RT/EXTN</th>
                                             <th className="text-center" style={styles.tabtrtd10}>LT/FLEX</th>
                                             <th className="text-center" style={styles.tabtrtd10}>Goal</th>
                                             <th className="text-center">Impression</th>
                                             <th className="text-center">Approach</th>
                                          </thead>
                                          <tbody>
                                             <tr>
                                                <td>Leg Length</td>
                                                <td><input type="text" name="leg_length_rt" id="leg_length_rt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="leg_length_lt" id="leg_length_lt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="leg_length_goal" id="leg_length_goal" className="form-control form-control-alternative" value="&#8804;3cm" disabled/></td>
                                                <td><textarea rows="2" type="text" name="leg_length_impression" id="leg_length_impression" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                <td><textarea rows="2" type="text" name="leg_length_approach" id="leg_length_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>   
                                             </tr>  
                                             <tr>
                                                <td>Hamstring Length</td>
                                                <td><input type="text" name="hamstring_length_rt" id="hamstring_length_rt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="hamstring_length_lt" id="hamstring_length_lt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="hamstring_length_goal" id="hamstring_length_goal" className="form-control form-control-alternative" value="&#8805;160&#176;" disabled/></td>
                                                <td><textarea rows="2" type="text" name="hamstring_length_impression" id="hamstring_length_impression" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                <td><textarea rows="2" type="text" name="hamstring_length_approach" id="hamstring_length_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>   
                                             </tr>
                                             <tr>
                                                <td>Iliopsoas Muscle Length</td>
                                                <td><input type="text" name="iliopsoas_muscle_length_rt" id="iliopsoas_muscle_length_rt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="iliopsoas_muscle_length_lt" id="iliopsoas_muscle_length_lt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="iliopsoas_muscle_length_goal" id="iliopsoas_muscle_length_goal" className="form-control form-control-alternative" value="&#8804;5&#176;" disabled/></td>
                                                <td><textarea rows="2" type="text" name="iliopsoas_muscle_impression" id="iliopsoas_muscle_impression" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                <td><textarea rows="2" type="text" name="iliopsoas_muscle_approach" id="iliopsoas_muscle_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>   
                                             </tr>
                                             <tr >
                                                <td>Quad Muscle Length</td>
                                                <td><input type="text" name="quad_musclelength_rt" id="quad_musclelength_rt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="quad_musclelength_lt" id="quad_musclelength_lt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="quad_musclelength_goal" id="quad_musclelength_goal" className="form-control form-control-alternative" value="&#8805;80&#176;" disabled/></td>
                                                <td><textarea rows="2" type="text" name="quad_musclelength_impression" id="quad_musclelength_impression" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                <td><textarea rows="2" type="text" name="quad_musclelength_approach" id="quad_musclelength_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>   
                                             </tr>
                                             <tr>
                                                <td>Hip Internal Rotation</td>
                                                <td><input type="text" name="hip_internal_rotation_rt" id="hip_internal_rotation_rt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="hip_internal_rotation_lt" id="hip_internal_rotation_lt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="hip_internal_rotation_goal" id="hip_internal_rotation_goal" className="form-control form-control-alternative" value="&#8805;30&#176;" disabled/></td>
                                                <td><textarea rows="2" type="text" name="hip_internal_impression" id="hip_internal_impression" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                <td><textarea rows="2" type="text" name="hip_internal_approach" id="hip_internal_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>   
                                             </tr>
                                             <tr>
                                                <td>Hip External Rotation</td>
                                                <td><input type="text" name="hip_external_rotation_rt" id="hip_external_rotation_rt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="hip_external_rotation_lt" id="hip_external_rotation_lt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="hip_external_rotation_goal" id="hip_external_rotation_goal" className="form-control form-control-alternative" value="&#8805;45&#176;" disabled/></td>
                                                <td><textarea rows="2" type="text" name="hip_external_impression" id="hip_external_impression" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                <td><textarea rows="2" type="text" name="hip_external_approach" id="hip_external_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>   
                                             </tr>
                                             <tr>
                                                <td>Piriformis Ms Length</td>
                                                <td><input type="text" name="piriformis_ms_length_rt" id="piriformis_ms_length_rt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="piriformis_ms_length_lt" id="piriformis_ms_length_lt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="piriformis_ms_length_goal" id="piriformis_ms_length_goal" className="form-control form-control-alternative" value="<10&#176;" disabled/></td>
                                                <td><textarea rows="2" type="text" name="piriformis_ms_impression" id="piriformis_ms_impression" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                <td><textarea rows="2" type="text" name="piriformis_ms_approach" id="piriformis_ms_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>   
                                             </tr>
                                             <tr>
                                                <td>DF Lunge Test</td>
                                                <td><input type="text" name="df_lunge_test_rt" id="df_lunge_test_rt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="df_lunge_test_lt" id="df_lunge_test_lt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="df_lunge_test_goal" id="df_lunge_test_goal" className="form-control form-control-alternative" value="&#8805;10cm" disabled/></td>
                                                <td><textarea rows="2" type="text" name="df_lunge_test_impression" id="df_lunge_test_impression" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                <td><textarea rows="2" type="text" name="df_lunge_test_approach" id="df_lunge_test_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>   
                                             </tr>
                                             <tr>
                                                <td>Single Leg Eyes Open</td>
                                                <td><input type="text" name="single_leg_eye_open_rt" id="single_leg_eye_open_rt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="single_leg_eye_open_lt" id="single_leg_eye_open_lt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="single_leg_eye_open_goal" id="single_leg_eye_open_goal" className="form-control form-control-alternative" value=">60 Sec" disabled/></td>
                                                <td rowSpan="2"><textarea rows="4" type="text" name="single_leg_impression" id="single_leg_impression" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                <td rowSpan="2"><textarea rows="4" type="text" name="single_leg_approach" id="single_leg_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>   
                                             </tr>
                                             <tr>
                                                <td>Single Leg Eyes Closed</td>
                                                <td><input type="text" name="single_leg_eye_closed_rt" id="single_leg_eye_closed_rt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="single_leg_eye_closed_lt" id="single_leg_eye_closed_lt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                <td><input type="text" name="single_leg_eye_closed_goal" id="single_leg_eye_closed_goal" className="form-control form-control-alternative" value=">60 Sec" disabled/></td>
                                             </tr>
                                                                                                                                  
                                          </tbody>
                                    </table>
                                 </div>
                              </RctCollapsibleCard>  
                           </div>  

                           <div className="col-sm-12 col-lg-12">
                              <RctCollapsibleCard heading="Component 6 - Glute Stability And Core"> 
                                    <div className="table-responsive">
                                    
                                       <table className="table align-items-center table-flush">
                                             <thead className="thead-light">
                                                <th className="text-center" style={styles.tabtrtd20}>Test</th>
                                                <th className="text-center" style={styles.tabtrtd10}>RT</th>
                                                <th className="text-center" style={styles.tabtrtd10}>LT</th>
                                                <th className="text-center">Impression</th>
                                                <th className="text-center">Approach</th>
                                             </thead>
                                             <tbody>
                                                <tr>
                                                   <td>Level 1: &#8804;60 sec</td>
                                                   <td><input type="text" name="glute_level_one_rt" id="glute_level_one_rt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                   <td><input type="text" name="glute_level_one_lt" id="glute_level_one_lt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                   <td rowSpan="3"><textarea rows="6" type="text" name="glute_level_impression" id="glute_level_impression" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                   <td rowSpan="3"><textarea rows="6" type="text" name="glute_level_approach" id="glute_level_approach" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea></td>
                                                </tr>
                                                <tr>
                                                   <td>Level 2: = 60-90 sec</td>
                                                   <td><input type="text" name="glute_level_two_rt" id="glute_level_two_rt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                   <td><input type="text" name="glute_level_two_lt" id="glute_level_two_lt" className="form-control form-control-alternative"  maxLength="6" /></td>
                                                </tr>
                                                <tr >
                                                   <td>Level 3: &#8805;90 sec</td>
                                                   <td><input type="text" name="glute_level_three_rt" id="glute_level_three_rt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                   <td><input type="text" name="glute_level_three_lt" id="glute_level_three_lt" className="form-control form-control-alternative"  maxLength="6"/></td>
                                                </tr>
                                             </tbody>
                                       </table>
                                       <table className="table align-items-center table-flush">
                                             <thead className="thead-light">
                                                <th className="text-center">TA Control in Supine</th>
                                                <th colSpan="3" className="text-center">Impression</th>
                                             </thead>
                                             <tbody>
                                                <tr>
                                                   <td>Level 1 - Crook Lying</td>
                                                   <td><input type="text" name="tacontrol_level_one" id="tacontrol_level_one" className="form-control form-control-alternative" /></td>
                                                </tr>
                                                <tr>
                                                   <td>Level 2 - Single Leg Heel Slide</td>
                                                   <td><input type="text" name="tacontrol_level_two" id="tacontrol_level_two" className="form-control form-control-alternative" /></td>
                                                </tr>
                                                <tr>
                                                   <td>Level 3 - Single Leg Knee Extension</td>
                                                   <td><input type="text" name="tacontrol_level_three" id="tacontrol_level_three" className="form-control form-control-alternative" /></td>
                                                </tr>
                                                <tr>
                                                   <td>Level 4 - Double Leg Heel Slide</td>
                                                   <td><input type="text" name="tacontrol_level_four" id="tacontrol_level_four" className="form-control form-control-alternative" /></td>
                                                </tr>
                                                <tr>
                                                   <td>Level 5 - Double Leg Knee Extension</td>
                                                   <td><input type="text" name="tacontrol_level_five" id="tacontrol_level_five" className="form-control form-control-alternative" /></td>
                                                </tr>
                                             
                                             </tbody>
                                       </table>
                                    </div>
                              </RctCollapsibleCard>  
                           </div> 

                           <div className="col-sm-12 col-lg-12">
                              <RctCollapsibleCard heading="Overall Impression"> 
                                    <div className="table-responsive">
                                    
                                       <table className="table align-items-center table-flush">
                                             <tbody>
                                                <tr>
                                                   <td>
                                                         <input type="text" name="overall_impression_one" id="overall_impression_one" className="form-control form-control-alternative" />
                                                   </td>
                                                </tr>
                                                <tr>
                                                   <td>
                                                         <input type="text" name="overall_impression_two" id="overall_impression_two" className="form-control form-control-alternative" />
                                                   </td>
                                                </tr>
                                                <tr>
                                                   <td>
                                                         <input type="text" name="overall_impression_three" id="overall_impression_three" className="form-control form-control-alternative" />
                                                   </td>
                                                </tr>
                                                <tr>
                                                   <td>
                                                         <input type="text" name="overall_impression_four" id="overall_impression_four" className="form-control form-control-alternative" />
                                                   </td>
                                                </tr>
                                                <tr>
                                                   <td>
                                                         <input type="text" name="overall_impression_five" id="overall_impression_five" className="form-control form-control-alternative" />
                                                   </td>
                                                </tr>
                                                   <tr>
                                                   <td>
                                                         <input type="text" name="overall_impression_six" id="overall_impression_six" className="form-control form-control-alternative" />
                                                   </td>
                                                </tr>
                                                <tr>
                                                   <td>
                                                         <input type="text" name="overall_impression_seven" id="overall_impression_seven" className="form-control form-control-alternative" />
                                                   </td>
                                                </tr>
                                                <tr>
                                                   <td>
                                                         <input type="text" name="overall_impression_eight" id="overall_impression_eight" className="form-control form-control-alternative" />
                                                   </td>
                                                </tr>
                                             </tbody>
                                       </table>
                                    </div>
                              </RctCollapsibleCard>  
                           </div> 
                           
                           <div className="col-sm-12 col-lg-8">
                              <RctCollapsibleCard heading="Abbreviations"> 
                                 <div className="table-responsive">                                 
                                    <table className="table align-items-center table-flush">
                                          <thead className="thead-light">
                                             <th className="text-center"></th>
                                          </thead>
                                          <tbody>
                                             {postureabbreivation.map((abbrval) => (
                                                <tr>
                                                   <td>{abbrval.pa_name}</td>
                                                </tr>                                                   
                                             ))}                                                                           
                                          </tbody>
                                    </table>
                                 </div>
                              </RctCollapsibleCard>  
                           </div> 
                          
                           
                        </div>
                        }
                        {this.state.addinnerdiv &&                        
                        <div className="form-group" style={styles.wrapper}> 
                              <button type="submit" className="mr-3 mb-3 btn btn-outline-primary" disabled={this.state.loader} >Submit</button>
                                 {this.state.loader && <CircularProgress size={24} style={styles.buttonProgress} />}   
                                 <button type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.props.onClick} >Back</button> 
                        </div> 
                        }
                     </form> 
                  </div>
         </div>
      );
   }
}


const mapStateToProps = ({ mostlyused, mskassessment }) => {
    const { studentlists, loading } = mostlyused;
	 const { posturehead, postureshoulders, posturethoracic, posturelumbar, posturepelvis, postureknee, posturefeet, postureglenohumeral, postureabbreivation } = mskassessment;
    return { studentlists, posturehead, postureshoulders, posturethoracic, posturelumbar, posturepelvis, postureknee, posturefeet, postureglenohumeral, postureabbreivation, loading };
}

export default connect(mapStateToProps, {
    allStudents,
    checkMskAssessment,
    addMskAssessment,
    fetchPostureList,
    getMedicalDetails
})(AddMSKElements); 